import { DeleteKmz } from './delete_kmz.function';
import { getAllKmzsWithFilters } from './get_all_kmz_with_filters.function';

/**
 * Deletes a KMZ file while preserving the visibility state of other KMZ files
 * @param {string} kmzName - Name of the KMZ file to delete
 * @param {string} network - Network type
 * @param {Array} currentVisibleKmzs - Currently visible KMZ names
 * @param {Function} setKmzData - Function to update KMZ data
 * @param {Function} setSelectedKmzIds - Function to update selected KMZ IDs
 * @param {Object} filters - Filter parameters (regions, cities, etc.)
 * @returns {Promise<Object>} - Response from delete operation
 */
export const deleteKmzWithStatePreservation = async (
  kmzName,
  network,
  currentVisibleKmzs,
  setKmzData,
  setSelectedKmzIds,
  filters = {}
) => {
  try {
    // Delete the KMZ file
    const resp = await DeleteKmz(kmzName, network);

    // Remove the deleted KMZ from visible list
    const updatedVisibleKmzs = currentVisibleKmzs.filter((id) => id !== kmzName);

    // Refresh KMZ data with current filters
    const { regionsArray = [], citiesArray = [], kmzNetworks, kmzPartner } = filters;
    const refreshedData = await getAllKmzsWithFilters(
      '',
      '',
      kmzNetworks,
      kmzPartner,
      regionsArray,
      citiesArray
    );

    // Update KMZ data
    setKmzData(refreshedData?.response);

    // Restore visibility state for remaining KMZ files
    // Only keep KMZ names that still exist in the refreshed data
    const existingKmzNames = refreshedData?.response?.map((kmz) => kmz.name) || [];
    const validVisibleKmzs = updatedVisibleKmzs.filter((name) => existingKmzNames.includes(name));

    setSelectedKmzIds(validVisibleKmzs);

    return resp;
  } catch (error) {
    console.error('Error in deleteKmzWithStatePreservation:', error);
    throw error;
  }
};
